import { localToUsdAmount } from './balanceUtils';
import type { DocumentLineForm } from './documentLineTypes';

const OA_PREFIX = '__oa:';

/** Persist outstanding amount in notes so draft reload keeps Pay/Left open correct. */
export const encodeOpenBalanceNote = (notes: string | undefined, openBalance: string | undefined) => {
  const clean = (notes || '')
    .split('\n')
    .filter((line) => !line.trim().startsWith(OA_PREFIX))
    .join('\n')
    .trim();
  const oa = openBalance?.trim();
  if (!oa || !(Number(oa) > 0)) return clean || undefined;
  return clean ? `${OA_PREFIX}${oa}\n${clean}` : `${OA_PREFIX}${oa}`;
};

export const decodeOpenBalanceNote = (notes: string | undefined | null): { openBalance: string; notes: string } => {
  const raw = notes || '';
  const lines = raw.split('\n');
  const oaLine = lines.find((line) => line.trim().startsWith(OA_PREFIX));
  const rest = lines.filter((line) => !line.trim().startsWith(OA_PREFIX)).join('\n').trim();
  const openBalance = oaLine ? oaLine.trim().slice(OA_PREFIX.length).trim() : '';
  return { openBalance, notes: rest };
};

export const mapLinesToPayload = (lines: DocumentLineForm[]) =>
  lines
    .filter((l) => l.companyId && l.accountId && (l.debitLocal || l.creditLocal || l.debitUSD || l.creditUSD))
    .map((l, idx) => {
      const debitLocal = l.debitLocal ? Math.round(Number(l.debitLocal) * 100) / 100 : 0;
      const creditLocal = l.creditLocal ? Math.round(Number(l.creditLocal) * 100) / 100 : 0;
      const rate = l.rate ? Number(l.rate) : undefined;
      return {
        companyId: Number(l.companyId),
        accountId: Number(l.accountId),
        debitLocal,
        creditLocal,
        currencyId: l.currencyId ? Number(l.currencyId) : undefined,
        rate,
        debitUSD: localToUsdAmount(debitLocal, rate),
        creditUSD: localToUsdAmount(creditLocal, rate),
        narrative: l.narrative || undefined,
        plPeriodFrom: l.plPeriodFrom || undefined,
        plPeriodTo: l.plPeriodTo || undefined,
        dn: l.dn || undefined,
        notes: encodeOpenBalanceNote(l.notes, l.openBalance),
        linkNumber: l.linkNumber || undefined,
        dueDate: l.dueDate || undefined,
        lineOrder: idx + 1,
      };
    });
